export const SERVICES = 'services';
export const BUILDING_COMPLEXES = 'building_complexes';
export const EMPLOYEES = 'employees';
export const REGIONS = 'regions';
export const SKILLS = 'skills';

const toInt = i => parseInt(i);

export const QUERY_STRUCTURE = [
  { key: SERVICES, default: () => [], format: v => v.map(toInt) },
  { key: BUILDING_COMPLEXES, default: () => [], format: v => v.map(toInt) },
  { key: EMPLOYEES, default: () => [], format: v => v.map(toInt) },
  { key: REGIONS, default: () => [], format: v => v.map(toInt) },
  { key: SKILLS, default: () => [], format: v => v.map(toInt) }
];

export default Object.freeze({
  SERVICES,
  BUILDING_COMPLEXES,
  EMPLOYEES,
  REGIONS,
  SKILLS
});
